export default "<p>\n  demandsensingspenddashbaord works!\n</p>\n";